import { PermissionsEnum } from '@/auth/interfaces';
import { SaveTiketUsersAllActions } from '../../shared/saveTiketUsers';
import { useCheckPermissions } from '@/shared';

export interface CreateTiketUsuariosPage {}

const CreateTiketUsuariosPage: React.FC<CreateTiketUsuariosPage> = () => {
  useCheckPermissions(PermissionsEnum.api_add_ticketuser);

  return <SaveTiketUsersAllActions titlePage="Crear Tickets de usuario" />;
};

export default CreateTiketUsuariosPage;
